// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 通过number获取积分活动 GET /point_activity/find/number */
export async function pointActivityFindNumberUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.pointActivityFindNumberUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultPointActivityResp>('/point_activity/find/number', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
